import React from 'react';
import { BoardNodesContext } from 'contexts/BoardNodesContext';
import type { BoardNodesContextValue } from 'contexts/BoardNodesContext';

// Define the types
interface BoardNodesProviderProps {
  children: React.ReactNode;
}

// Create a Provider component
const BoardNodesProvider = ({ children }: BoardNodesProviderProps) => {
  const [selectedNodes, setSelectedNodes] = React.useState<string[]>([]);
  const [isBoardNodeCollapsedView, setIsBoardNodeCollapsedView] =
    React.useState<boolean>(false);

  const handleAddToNodeSelection = (nodeID: string) => {
    setSelectedNodes((prev) => {
      if (prev.includes(nodeID)) {
        return prev;
      }
      return [...prev, nodeID];
    });
  };

  const handleRemoveNodesFromSelection = (nodeID: string) => {
    setSelectedNodes((prev) =>
      prev.filter((nodeIdToRemove) => nodeIdToRemove !== nodeID)
    );
  };
  const clearSelection = () => {
    setSelectedNodes([]);
  };
  const contextValue: BoardNodesContextValue = {
    selectedNodes: selectedNodes,
    handleRemoveNodesFromSelection,
    handleAddToNodeSelection,
    clearSelection,
    isBoardNodeCollapsedView,
    setIsBoardNodeCollapsedView,
    setSelectedNodes,
  };

  return (
    <BoardNodesContext.Provider value={contextValue}>
      {children}
    </BoardNodesContext.Provider>
  );
};

export default BoardNodesProvider;
